import { useRef } from 'react';
import cx from 'classnames';
import { useReactDndConstructs } from '../../dnd/ReactDndContext';
import { getDndDesignTokens } from '../../style/reactDnd/DndStyleTokens';
import { useDesignTokens } from '../../theme';
import { TileDragType } from './TileDragPreview';
import cn from './Tile.css.json';
import './Tile.css';
export const useTileDroppable = props => {
  const {
    useDrop
  } = useReactDndConstructs();
  const ref = useRef(null);
  const dt = useDesignTokens();
  const dndStyle = getDndDesignTokens(dt);
  const dropMode = props.dropMode ?? 'insert';
  const [{
    dropClassName,
    isOver
  }, tileDropZoneConnect] = useDrop({
    accept: [TileDragType],
    canDrop: item => !!props.allowDrop && (!props.allowDropDndPrefixes || props.allowDropDndPrefixes.includes(item.dndProps?.dndPrefix ?? '')) && (
    // A tile cannot be dropped on itself
    props.dndPrefix !== item.dndProps?.dndPrefix || item.index !== props.index),
    collect: monitor => {
      const isOver = monitor.isOver() && monitor.canDrop();
      const dragIndex = monitor.getItem()?.index;
      const dragDndPrefix = monitor.getItem()?.dndProps?.dndPrefix;
      const dropClassName = dropMode === 'insert' ? cx(cn.dropLine,
      // When dragging a tile within the same tile list:
      // show the drop line on the left of the tiles that are on the left
      // show the drop line on the right of the tiles that are on the right
      dragDndPrefix === props.dndPrefix && dragIndex !== undefined && props.index !== undefined && props.index > dragIndex && cn.placeAtEnd) : cn.dragOver;
      return {
        isOver,
        dropClassName: isOver ? dropClassName : undefined
      };
    },
    drop: (item, monitor) => {
      if (monitor.didDrop() || !monitor.canDrop()) return;
      props.onDrop?.({
        dropIndex: props.index,
        droppedItem: item,
        monitor
      });
    }
  });
  tileDropZoneConnect(ref);
  return {
    ref,
    dropClassName,
    isOver,
    style: dndStyle,
    tileDropZoneConnect
  };
};
//# sourceMappingURL=useTileDroppable.js.map